
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/members-day",
      function () {
        return require("private-next-pages/members-day/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/members-day"])
      });
    }
  